module.exports = __webpack_public_path__ + "static/img/SAVOIA-OAK.71654b2.png";


//////////////////
// WEBPACK FOOTER
// ./static/materials/cortina/SAVOIA-OAK.png
// module id = UygX
// module chunks = 0